import { detachTrack } from "./detachTrack";
import { JointLocalTrack } from "@/types/call";

export const stopMediaPreview = (track: JointLocalTrack) => {
  track.stop();
  detachTrack(track);
};
